//Core
import React, { useReducer } from "react"

//Action
import formActions from "../actions/formActions"

//Itils
import axios from "axios"

//Helpers
import {
  validateName,
  validatePhoneNumber,
  transformPhoneAfterMask,
} from "../helpers/validation"

const {
  START_FETCH,
  FINISH_FETCH,
  FETCH_SUCCESS,
  FETCH_FAIL,
  CHANGE_NAME,
  VALID_NAME,
  CHANGE_PHONE,
  VALID_PHONE,
} = formActions

const getUrlParams = () => {
  if (typeof window !== `undefined`) {
    return window.location.search
      .substr(1)
      .split("&")
      .map(el => el.split("="))
      .reduce((acc, arr) => ((acc[arr[0]] = arr[1]), acc), {})
  } else return {}
}
const checkChannel = () => {
  const { friends } = getUrlParams()

  return friends
}

const initialState = {
  fetch: false,
  success: false,
  channel: checkChannel(),
  fail: false,
  name: { valid: false, value: "", checked: false },
  phone: { valid: false, value: "", checked: false },
}

const reducer = (state, action) => {
  switch (action.type) {
    case START_FETCH:
      return { ...state, fetch: true }
    case FINISH_FETCH:
      return { ...state, ...initialState }
    case FETCH_SUCCESS:
      return { ...state, fetch: false, success: true }
    case FETCH_FAIL:
      return { ...state, fetch: false, fail: true }

    case CHANGE_NAME:
      return { ...state, name: { ...state.name, value: action.payload } }
    case VALID_NAME:
      return {
        ...state,
        name: { ...state.name, valid: action.payload, checked: true },
      }

    case CHANGE_PHONE:
      return { ...state, phone: { ...state.phone, value: action.payload } }
    case VALID_PHONE:
      return {
        ...state,
        phone: { ...state.phone, valid: action.payload, checked: true },
      }

    default:
      return state
  }
}

const useForm = (link, product, source) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  //UI
  const startFetch = () => dispatch({ type: START_FETCH })
  const finishFetch = () => dispatch({ type: FINISH_FETCH })
  const fetchSuccess = () => dispatch({ type: FETCH_SUCCESS })
  const fetchFail = () => dispatch({ type: FETCH_FAIL })

  //Name
  const changeName = name => dispatch({ type: CHANGE_NAME, payload: name })
  const validName = isValidName =>
    dispatch({ type: VALID_NAME, payload: isValidName })

  //Phone
  const changePhone = phone => dispatch({ type: CHANGE_PHONE, payload: phone })
  const validPhone = isValidPhone =>
    dispatch({ type: VALID_PHONE, payload: isValidPhone })

  const onClick = async () => {
    try {
      const { phone, name, channel } = state
      console.log("channel", channel)

      ///Transform form after mask
      const normalPhone = transformPhoneAfterMask(phone.value)

      //Validate fileds
      const isValidPhone = validatePhoneNumber(normalPhone)
      const isValidName = validateName(name.value)

      //Set fields
      validPhone(isValidPhone)
      validName(isValidName)

      if (isValidPhone && isValidName) {
        startFetch()
        try {
          const res = await axios.post(link, {
            fio: name.value,
            phone: "+" + normalPhone,
            channel,
            product,
            source,
            login: source,
          })

          console.log(res)
          res.status === 201 || res.status == 200 ? fetchSuccess() : fetchFail()
        } catch (error) {
          console.log("error", error)
          fetchFail()
        } finally {
          finishFetch()
        }
      }
    } catch (error) {
      console.log("err", error)
    }
  }

  return {
    state,
    changeName,
    changePhone,
    onClick,
  }
}

export default useForm
